<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Conta</h5>
                <hr>
                <TabView>					
                    <TabPanel header="Meus Dados" class="p-mt-3">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-4">
                                <label>Nome</label>
                                <InputText v-model="usuario.nome"  readonly/>				
                            </div>
                            <div class="p-field p-col-12 p-md-4">
                                <label>E-mail</label>
                                <InputText v-model="usuario.email"  readonly/>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-4">
                                <label>Login</label>
                                <InputText v-model="usuario.nomeLogin"  readonly/>				
                            </div>
                            <div class="p-field p-col-12 p-md-4">
                                <label>Perfil</label>
                                <InputText v-model="perfil.nome"  readonly/>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-4">
                                <label>Empresas</label>
                                <Listbox :options="cnpjs" optionLabel="razaoSocial" listStyle="height:200px" readonly/>				
                            </div>
                            <div class="p-field p-col-12 p-md-4">
                                <label>Centros de Custos</label>
                                <Listbox :options="centrosCustos" optionLabel="nome" listStyle="height:200px" readonly/>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Senha" class="p-mt-3">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-4">
                                <label>Senha</label>
                                <Password v-model.trim="senha" :feedback="false"/>				
                            </div>                           
                        </div>
                        <div class="p-fluid p-formgrid p-grid">                           
                            <div class="p-field p-col-12 p-md-4">
                                <label>Repetir senha</label>
                                <Password v-model.trim="repetirSenha" :feedback="false"/>
                            </div>
                        </div>
                        <Button label="Salvar" icon="pi pi-check" class="p-mt-3" @click="alterarSenha"/>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>

<script>
import UsuarioService from '@/service/UsuarioService'; 
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
    usuarioService: null,
    data() {
        return {
            usuario: {},
            perfil: {},
            cnpjs: [],
            centrosCustos: [],
            senha: '',
            repetirSenha: '',
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']), 
        buscar() {
            let usuarioRequisicao = {...this.getDadosRequisicao()};           
            this.usuarioService.buscar(usuarioRequisicao)
				.then(resp => {                   
                    this.usuario = resp.data.usuario;
                    this.perfil = resp.data.perfil;
                    this.centrosCustos = resp.data.centrosCustos;
                    this.centrosCustos.forEach(ctc => {
                        ctc.nome = ctc.nome +' '+ctc.tipo;
                    });
                    this.cnpjs = resp.data.cnpjs;
                    this.cnpjs.forEach(cnpj => {
                        cnpj.razaoSocial = cnpj.numero+' '+cnpj.razaoSocial;
                    });
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        alterarSenha() {
            if(this.senha.length < 8 || this.repetirSenha.length < 8) {
                exibirMensagemSis(this, 'A senha deverá ser formada por 8 caracteres, números e letras. No minímo 1 maiúsculo e 1 minúsuculo.', true);
                return;
            } else if(this.senha != this.repetirSenha) {
                exibirMensagemSis(this, 'Não são iguais', true);
                return;
            }
            let requisicao = {
                senha: this.senha,
                repetirSenha: this.repetirSenha,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };           
            this.usuarioService.alterarSenha(requisicao)
				.then(resp => {                   
                    this.senha = '';
                    this.repetirSenha = '';
                    exibirMensagem(this, resp);	
                })
                .catch(erro => {exibirMensagem(this, erro)});            
        }
    },
    created() {
        this.usuarioService = new UsuarioService();
    },
    mounted() {
        this.buscar();
    }
}
</script>

<style>

</style>